<div class="mantenimiento-container">

  <h1>Plataforma en mantenimiento</h1>
  <img src="assets/mantenimiento.webp" alt="Logo" class="mantenimiento-img" />
  <p>La plataforma está temporalmente fuera de servicio por tareas de mantenimiento.<br>
  Por favor, vuelve a intentarlo más tarde.</p>
</div>
